import { post } from './fetcher';

export default class SupportService {
  async sendTicket(data: any) {
    return await post('/tickets', data);
  }
}